import type { DescuentoEnergiaModel } from "@/.shared/.api";

export class Descuento implements DescuentoEnergiaModel {

  Id: string | null;
  Nombre: string;
  NombreTecnico: string;
  Cuantia: number;

  constructor(){
    this.Id = null;
    this.Nombre = "";
    this.NombreTecnico = "";
    this.Cuantia = 0;
  }
}